<div class="w-100 d-flex justify-content-center align-items-center" style="color: var(--blue-base); height: 100%">
  <div
    class="spinner-border"
    [ngStyle]="{ width: len ? len : '5em', height: len ? len : '5em' }"
    role="status"
  ></div>
</div>
